export const trackerConstants = {
  TRACKER_LIST_REQUEST: 'TRACKER_LIST_REQUEST',
  TRACKER_LIST_SUCCESS: 'TRACKER_LIST_SUCCESS',
  TRACKER_LIST_FAILURE: 'TRACKER_LIST_FAILURE',
  TRACKER_LIST_CHANGED: 'TRACKER_LIST_CHANGED',
  TRACKER_LIST_PAGINATION: 'TRACKER_LIST_PAGINATION',

  TRACKER_LOAD_REQUEST: 'TRACKER_LOAD_REQUEST',
  TRACKER_LOAD_SUCCESS: 'TRACKER_LOAD_SUCCESS',
  TRACKER_LOAD_FAILURE: 'TRACKER_LOAD_FAILURE',

  TRACKER_SAVE_REQUEST: 'TRACKER_SAVE_REQUEST',
  TRACKER_SAVE_SUCCESS: 'TRACKER_SAVE_SUCCESS',
  TRACKER_SAVE_FAILURE: 'TRACKER_SAVE_FAILURE',
};
